<template>
  <v-app>
    <v-app-bar color="primary" dark>
      <v-app-bar-nav-icon
        @click="drawer = true"
        aria-label="app bar icon"
      ></v-app-bar-nav-icon>

      <router-link color="secondary" to="/" class="main-logo-link">
        <img src="@/assets/logo.png" alt="Team Logo" />
        <v-toolbar-title id="logo-wordmark" class="baloo white--text ml-2"
          >Soheco</v-toolbar-title
        >
      </router-link>

      <v-spacer></v-spacer>

      <div class="desktop-only-app-bar">
        <router-link to="/search" @click="this.$ga.event({
  eventCategory: 'home',
  eventAction: 'route-to-search-page',
  eventLabel: 'app-bar'
})">
          <v-btn text class="pl-12 pr-12" aria-label="Search button">
            <v-icon large class="pr-3">
              mdi-magnify
            </v-icon>
            <span class="search-text">Search</span>
          </v-btn>
        </router-link>
        <router-link to="/cart" @click="this.$ga.event({
  eventCategory: 'home',
  eventAction: 'route-to-cart-page',
  eventLabel: 'app-bar'
})">
          <v-btn text>
            <v-badge
              title="Your Cart Items"
              class="ml-12 mr-12"
              :content="$store.state.cartItems.length"
              :value="$store.state.cartItems.length"
              color="green"
              overlap
            >
              <v-icon large>mdi-cart</v-icon>
              <span class="white--text pl-4">Cart</span>
            </v-badge>
          </v-btn>
        </router-link>

        <Sign v-if="$store.state.user == null" />
        <v-menu
          v-else
          transition="slide - y - transition"
          bottom
          :offset-y="true"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-avatar v-bind="attrs" v-on="on" color="orange">
              <v-icon>mdi-account-circle</v-icon>
            </v-avatar>
          </template>
          <v-list>
            <v-list-item>
              <v-list-item-title>
                Welcome back,
                <b>
                  {{ $store.state.displayName }}
                </b>
              </v-list-item-title>
            </v-list-item>
            <v-list-item>
              <router-link to="/refine" @click="this.$ga.event({
  eventCategory: 'home',
  eventAction: 'route-to-refine-page',
  eventLabel: 'menu'
})">
                <v-list-item-title>
                  <v-icon>mdi-table-edit</v-icon>
                  Refine your Recommendations</v-list-item-title
                >
              </router-link>
            </v-list-item>
            <v-list-item @click="signOut()">
              <v-list-item-title>
                <v-icon>mdi-logout</v-icon>

                Sign Out</v-list-item-title
              >
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" absolute temporary>
      <v-list nav dense>
        <v-list-item-group active-class="primary--text text--accent-4">
          <router-link to="/" @click="this.$ga.event({
  eventCategory: 'home',
  eventAction: 'route-to-search-page',
  eventLabel: 'drawer'
})">
            <v-list-item class="mt-6">
              <v-list-item-icon>
                <v-icon>mdi-home</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Home</v-list-item-title>
            </v-list-item>
          </router-link>

          <router-link to="/cart" @click="this.$ga.event({
  eventCategory: 'home',
  eventAction: 'route-to-cart-page',
  eventLabel: 'drawer'
})">
            <v-list-item class="mt-6">
              <v-badge
                title="Your Cart Items"
                :content="$store.state.cartItems.length"
                :value="$store.state.cartItems.length"
                color="green"
                overlap
              >
                <v-list-item-icon>
                  <v-icon>
                    mdi-cart
                  </v-icon>
                </v-list-item-icon>
              </v-badge>

              <v-list-item-title>Cart</v-list-item-title>
            </v-list-item>
          </router-link>

          <router-link to="/recommendations" @click="this.$ga.event({
  eventCategory: 'home',
  eventAction: 'route-to-recommendations-page',
  eventLabel: 'drawer'
})">
            <v-list-item class="mt-6">
              <v-list-item-icon>
                <v-icon>
                  mdi-gift
                </v-icon>
              </v-list-item-icon>

              <v-list-item-title>Recommendations</v-list-item-title>
            </v-list-item>
          </router-link>

          <router-link to="/search" @click="this.$ga.event({
  eventCategory: 'home',
  eventAction: 'route-to-search-page',
  eventLabel: 'drawer'
})">
            <v-list-item class="mt-6">
              <v-list-item-icon>
                <v-icon>
                  mdi-magnify
                </v-icon>
              </v-list-item-icon>
              <v-list-item-title>Search</v-list-item-title>
            </v-list-item>
          </router-link>

          <router-link to="/assessment" @click="this.$ga.event({
  eventCategory: 'home',
  eventAction: 'route-to-assessment-page',
  eventLabel: 'drawer'
})">
            <v-list-item class="mt-6">
              <v-list-item-icon>
                <v-icon>
                  mdi-file-document
                </v-icon>
              </v-list-item-icon>
              <v-list-item-title>Assessment</v-list-item-title>
            </v-list-item>
          </router-link>

          <v-list-item class="mt-12" v-if="$store.state.user == null">
            <Sign />
          </v-list-item>
          <div v-else class="mt-12">
            <v-list-item>
              <v-list-item-title>
                <v-icon>mdi-account</v-icon>
                Welcome back,
                <b>
                  {{ $store.state.displayName }}
                </b></v-list-item-title
              >
            </v-list-item>
            <v-list-item>
              <router-link to="/refine" @click="this.$ga.event({
  eventCategory: 'home',
  eventAction: 'route-to-refine-page',
  eventLabel: 'drawer'
})">
                <v-list-item-title>
                  <v-icon>mdi-table-edit</v-icon>
                  Refine your Recommendations</v-list-item-title
                >
              </router-link>
            </v-list-item>
            <v-list-item @click="signOut()">
              <v-list-item-title>
                <v-icon>mdi-logout</v-icon>

                Sign Out</v-list-item-title
              >
            </v-list-item>
          </div>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-main>
      <router-view />

      <v-snackbar
        v-for="(snackbar, index) in snackbars.filter((s) => s.showing)"
        :key="snackbar.text + Math.random()"
        v-model="snackbar.showing"
        :timeout="snackbar.timeout"
        :color="snackbar.color"
        :style="`bottom: ${index * 70 + 8}px`"
      >
        {{ snackbar.text }}

        <v-btn
          text
          @click="snackbar.showing = false"
          aria-label="Close Snackbar button"
        >
          Close
        </v-btn>
      </v-snackbar>

      <v-footer
        v-if="!['Assessment'].includes($route.name)"
        color="primary"
        padless
      >
        <img
          id="hobby"
          src="@/assets/hobby-clear.png"
          alt="Footer illustration"
        />
        <v-row justify="center" no-gutters>
          <v-btn
            v-for="link in links"
            :key="link.name"
            :to="link.route"
            color="white"
            text
            rounded
            class="my-2"
            :aria-label="link.name"
          >
            {{ link.name }}
          </v-btn>
          <v-col class="primary py-4 text-center white--text" cols="12">
            {{ new Date().getFullYear() }} — <strong>Soheco</strong>
          </v-col>
        </v-row>
      </v-footer>
    </v-main>
  </v-app>
</template>

<script>
import algoliasearch from 'algoliasearch/lite';
import Sign from './components/Sign';
import { mapState } from 'vuex';

export default {
  name: 'App',

  components: {
    Sign,
  },
  data() {
    return {
      drawer: false,
      searchClient: algoliasearch(
        'U7CA3GDTX2',
        'a56c7927f04fc5fda073a4b1ae942ef6'
      ),
      searchTerm: '',
      cartItems: 0,
      links: [
        { name: 'Home', route: '/' },
        { name: 'About Us', route: '/about' },
        { name: 'Blog', route: '/blog' },
        { name: 'Contact Us', route: '/contact' },
      ],
    };
  },
  watch: {
    $route: function() {
      // Check if given route is true, if it is then hide Nav.
      if (this.$route.path != '/') {
        document.querySelector('.videoask-embed__button--1ONxk').style.display =
          'none';
      } else {
        document.querySelector('.videoask-embed__button--1ONxk').style.display =
          'block';
      }
    },
  },
  computed: {
    isAssessmentView() {
      return this.$route.name === 'Assessment';
    },
    ...mapState({
      snackbars: (state) => state.snackbars,
    }),
  },
  methods: {
    signOut() {
      this.$store.dispatch('signOutAction');
    },
  },
};
</script>

<style lang="scss">
* {
  font-family: 'Public Sans', sans-serif !important;
}

.main-logo-link {
  display: flex;
  align-items: center;

  &:hover {
    filter: opacity(0.5);
    transition: 0.1s linear;
  }

  &:active {
    filter: opacity(0.5);
    transition: 0.1s linear;
  }
}

.baloo {
  font-family: 'Baloo Da 2', cursive !important;
  font-size: 2rem !important;
}

#hobby {
  display: flex;
  margin: auto;
  width: 73%;
  padding: 0 20% 0 20%;
}

.nav-link {
  color: white !important;
  text-decoration: none;
  padding: 2rem;
}

.v-application a {
  text-decoration: none;
}

.v-sheet.v-card {
  margin: 0.1rem;
}

/* .v-slide-group__next .v-icon.v-icon::before,
.v-slide-group__prev .v-icon.v-icon::before {
  font-size: 4rem;
} */

.v-snack:not(.v-snack--absolute) {
  height: unset !important;
}

.v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot {
  width: 40rem;
}

.v-window__next > button,
.v-window__prev > button {
  padding: 2.25rem !important;
}

.v-list-item__icon {
  margin-left: 0 !important;
}

@media screen and (max-width: 654px) {
  .soceng {
    display: none !important;
  }

  .search-text {
    display: none !important;
  }

  .row > .v-slide-group {
    padding: 0 !important;
  }

  .v-slide-group__next,
  .v-slide-group__prev {
    flex: 0 1 42px;
    min-width: unset;
  }
}

header {
  max-height: 65px !important;
}

.desktop-only-app-bar {
  display: none;
  align-items: center;
}

@media screen and (min-width: 1000px) {
  .desktop-only-app-bar {
    display: flex;
  }
}

.v-footer {
  position: absolute !important;
  bottom: 0px !important;
  width: 100% !important;
}

.v-main__wrap {
  padding-bottom: 20% !important;
}

/* home.vue carousel image size override */
.theme--dark.v-image {
  max-height: 30rem !important;
}
.v-window-item > .v-carousel__item > .v-responsive__content {
  background: rgba(6, 31, 56, 0.8) !important;
}

/* sign up card margin */
.v-dialog
  > .v-tabs
  > .v-window
  > .v-window__container
  > .v-window-item
  > .v-sheet.v-card {
  margin: 0 !important;
}

//horizontal scroll bar
.v-dialog {
  overflow-y: initial !important;
}
</style>
